import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, InputLabel } from '@mui/material';
import { compose } from 'redux';
import { Card, DynamicField, Button, TextField } from '@totalsoft/rocket-ui';
import { SkipNext, CheckCircle, CancelRounded } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { getDynamicFieldControlType } from 'utils/functions';
import { GridActionsWrapper } from 'components/common/CommonStyles';

const OfferPartnerQuestionsNewItemComponent = ({
  currentQuestion,
  questionnaire,
  onNextQuestionnaire,
  onFinishQuestionnaire,
  onSaveQuestionnaire,
  onCancelQuestionnaire,
  validation,
  options,
  dispatch,
  t
}) => {
  const onChangeDefaultValue = value => {
    dispatch({ type: 'OnCurrentQuestionPropertyChanged', propertyName: 'answer', propertyValue: value });
  };
  const onPropertyChanged = (propertyName, propertyValue) => {
    dispatch({ type: 'OnCurrentQuestionPropertyChanged', propertyName, propertyValue });
  };

  return (
    <Card title={questionnaire.questionnaireName}>
      <>
        <Grid container>
          {!currentQuestion.isEmptyQuestion && currentQuestion.loaded ? (
            <>
              <Grid container spacing={3} alignItems='center'>
                <Grid item xs={12} sm={8}>
                  <InputLabel color='primary'>
                    {currentQuestion.questionNo}.{currentQuestion.questionName}
                  </InputLabel>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DynamicField
                    id={currentQuestion.questionId}
                    controlType={getDynamicFieldControlType(currentQuestion.questionTypeCode)}
                    value={currentQuestion.answer || ''}
                    closeOnSelect={true}
                    disabled={false}
                    options={options}
                    onChange={onChangeDefaultValue}
                    error={!isValid(validation.answer)}
                    helperText={getErrors(validation.answer)}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    multiline
                    fullWidth
                    name={'freeTxt'}
                    value={currentQuestion.freeTxt}
                    label={t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.FreeTxt')}
                    onChange={value => onPropertyChanged('freeTxt', value)}
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>
        <Grid container mt={2} justifyContent='space-between'>
          <GridActionsWrapper item>
            {currentQuestion.loaded && !currentQuestion.isEmptyQuestion && !currentQuestion.isFinalQuestion ? (
              <Button
                id={'offerPartnerQuestionnaire_saveBtn'}
                color={isValid(validation.answer) ? 'success' : 'warning'}
                startIcon={<CheckCircle />}
                disabled={!questionnaire.loaded || !(validation |> isValid) || (validation |> getErrors) !== ''}
                onClick={onSaveQuestionnaire}
              >
                {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.SaveQuestionnaire')}
              </Button>
            ) : (
              <></>
            )}
            <Button id={'offerPartnerQuestionnaire_cancelBtn'} startIcon={<CancelRounded />} color='error' onClick={onCancelQuestionnaire}>
              {t('Cancel')}
            </Button>
          </GridActionsWrapper>
          {/*this line creates space between buttons to the left and buttons to the right and it pushes them all the way to the margins*/}
          <GridActionsWrapper item>
            {currentQuestion.loaded && !currentQuestion.isEmptyQuestion && !currentQuestion.isFinalQuestion ? (
              <Button
                id={'offerPartnerQuestionnaire_nextBtn'}
                startIcon={<SkipNext />}
                color={isValid(validation.answer) ? 'info' : 'warning'}
                disabled={!questionnaire.loaded || !(validation |> isValid) || (validation |> getErrors) !== ''}
                onClick={onNextQuestionnaire}
              >
                {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.NextQuestionnaire')}
              </Button>
            ) : (
              <></>
            )}
            {currentQuestion.loaded && !currentQuestion.isEmptyQuestion && currentQuestion.isFinalQuestion ? (
              <Button
                id={'offerPartnerQuestionnaire_finishBtn'}
                color={isValid(validation.answer) ? 'success' : 'warning'}
                startIcon={<CheckCircle />}
                disabled={!questionnaire.loaded || !(validation |> isValid) || (validation |> getErrors) !== ''}
                onClick={onFinishQuestionnaire}
              >
                {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.FinishQuestionnaire')}
              </Button>
            ) : (
              <></>
            )}
          </GridActionsWrapper>
        </Grid>
      </>
    </Card>
  );
};
OfferPartnerQuestionsNewItemComponent.propTypes = {
  currentQuestion: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  questionnaire: PropTypes.object.isRequired,
  onNextQuestionnaire: PropTypes.func.isRequired,
  onFinishQuestionnaire: PropTypes.func.isRequired,
  onSaveQuestionnaire: PropTypes.func.isRequired,
  onCancelQuestionnaire: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  validation: PropTypes.object
};

export default compose(withTranslation())(OfferPartnerQuestionsNewItemComponent);
